import { useCallback, useState } from "react"
import type { FormInstance } from "antd/es/form/hooks/useForm"
import type { NamePath } from "antd/es/form/interface"

/**
 * The switch between picking a ZIP from a list and typing one, shared by the
 * project form's two address blocks. Emptying the field with `setFieldValue`
 * fires no `onChange`, so `onCleared` is how the ZIP control is told.
 */
export function useZipModeToggle<Values>(
  form: FormInstance<Values>,
  path: NamePath,
  onCleared: () => void
) {
  const [isCustomZip, setIsCustomZip] = useState(false)

  const toggleZipMode = useCallback(() => {
    setIsCustomZip((prev) => !prev)
    form.setFieldValue(path, null)
    onCleared()
  }, [form, path, onCleared])

  return { isCustomZip, toggleZipMode }
}
